import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { NamirasoftAlarmServer } from "namirasoft-alarm";
import { NamirasoftAPIProductServer, ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftNotificationSenderServer } from "namirasoft-notification-sender";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { AlarmLayout } from "./AlarmLayout";
import { AlarmRoutes } from "./AlarmRoutes";
import AlarmEditPage from "./pages/AlarmEditPage";
import AlarmListPage from "./pages/AlarmListPage";
import AlarmViewPage from "./pages/AlarmViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_ALARM}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_ALARM = new EnvService("REACT_APP_BASE_URL_ALARM", true).getString();
            let REACT_APP_BASE_URL_NOTIFICATION_SENDER = new EnvService("REACT_APP_BASE_URL_NOTIFICATION_SENDER", true).getString();
            let REACT_APP_BASE_URL_API_PRODUCT = new EnvService("REACT_APP_BASE_URL_API_PRODUCT", true).getString();

            let alarm = new NamirasoftAlarmServer(REACT_APP_BASE_URL_ALARM, result.account.token_manager, result.notifier.onError);
            let notification_sender = new NamirasoftNotificationSenderServer(REACT_APP_BASE_URL_NOTIFICATION_SENDER, result.account.token_manager, result.notifier.onError);
            let product = new NamirasoftAPIProductServer(REACT_APP_BASE_URL_API_PRODUCT, result.notifier.onError);

            let servers = { alarm, notification_sender, product };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={AlarmRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={AlarmRoutes.AlarmList} element={<AlarmListPage {...result} servers={servers} />} />
                            <Route path={AlarmRoutes.AlarmNew} element={<AlarmEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={AlarmRoutes.AlarmView(":id")} element={<AlarmViewPage {...result} servers={servers} />} />
                            <Route path={AlarmRoutes.AlarmEdit(":id")} element={<AlarmEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={AlarmRoutes.AlarmCopy(":id")} element={<AlarmEditPage {...result} servers={servers} isEdit={false} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={AlarmRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <AlarmLayout {...props}>
                {props.children}
            </AlarmLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;